export const MULTIPLE_SALON_CHART_KPI = {
  existingGuestRetention: 'field_existing_guest_retention',
  newGuestRetention: 'field_new_guest_retention',
  pColorTransactions: 'field_p_color_transactions',
  pGuestsPrebooked: 'field_p_guests_prebooked',
  pGuestsPurchasing: 'field_p_guests_purchasing',
  rpct: 'field_rpct',
  rprt: 'field_rprt',
  pTreatmentTransactions: 'field_p_treatment_transactions',
  pRetailSales: 'field_p_retail_sales',
  tnTransactionsBmrk: 'field_tn_transactions_bmrk',
  spRetention: 'field_sp_retention',
} as const;
